import isArray from 'lodash/isArray';
export var checkRequired = function checkRequired(props) {
  var validator = props.validator,
      validatorsOrOpts = props.validatorsOrOpts;
  var isRequired = false;

  if (validator && validator.name === 'required') {
    isRequired = true;
  }

  if (validatorsOrOpts && validatorsOrOpts.validators) {
    if (isArray(validatorsOrOpts.validators)) {
      validatorsOrOpts.validators.forEach(function (validator) {
        if (validator.name === 'required') {
          isRequired = true;
        }
      });
    } else {
      if (validatorsOrOpts.validators.name === 'required') {
        isRequired = true;
      }
    }
  }

  return isRequired;
};